import {
  $1_TRIAL_DESCRIPTION,
  GUSET_USER_DESCRIPTION,
  ANNUAL_SPECIAL_DESCRIPTION,
  NINETY_DAY_INTRO_DESCRIPTION,
  FIVE_MONTH_INTRO_DESCRIPTION,
  FREE_REGISTRATION_DESCRIPTION,
  ONE_HOURMASTER_CLASS_DESCRIPTION,
  LIVE_OPPORTUNITY_CALL_DESCRIPTION,
  SEVEN_DAYS_FREE_TRIAL_DESCRIPTION,
  EXCLUSIVE_MEMBER_ADMIN_DESCRIPTION,
  INSTANT_SIGNUP_PAYMENT_DESCRIPTION,
} from "../../utils/globalConstants";
import { Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { toastrOnTopCenter } from "../../utils/toastr";
import { fetchAllPromoteStats } from "../../api/PromoteApi";
import DotPulseBackdrop from "../shared/components/DotPulseBackdrop";

function AllFunnelCard({ item, filter, handleCopyClick }) {
  const [showStats, setShowStats] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [statsData, setStatsData] = useState({
    views_count: 0,
    leads_count: 0,
    member_count: 0,
    guest_count: 0,
    opt_in_percentage: 0,
    member_conv_percentage: 0,
    funnel_conv_percentage: 0,
    guest_conv_percentage: 0,
    guest_to_member_conv_percentage: 0,
  });
  useEffect(() => {
    if (filter.period) setShowStats(false);
  }, [filter.period]);

  const toggleStats = () => {
    setShowStats((prev) => {
      const newState = !prev;
      if (newState) {
        getPromoteStates();
      }
      return newState;
    });
  };

  const getPromoteStates = async (e) => {
    if (e) {
      e.preventDefault();
    }
    setProcessing(true);
    try {
      const response = await fetchAllPromoteStats(filter);
      const type = item.funnel_type;
      if (response.data && response.data[type]) {
        setStatsData(response.data[type]);
      } else {
        setStatsData({
          views_count: 0,
          leads_count: 0,
          member_count: 0,
          guest_count: 0,
          opt_in_percentage: 0,
          member_conv_percentage: 0,
          funnel_conv_percentage: 0,
          guest_conv_percentage: 0,
          guest_to_member_conv_percentage: 0,
        });
      }
    } catch (error) {
      setProcessing(false);
      toastrOnTopCenter(error.message, "error");
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div
      className={`${
        ((item.sub_name === "Opt In" || item.sub_name === "VSL") &&
          (item.name === "Guest User" ||
            item.name === "7 Days Free Trial" ||
            item.name === "$1 Trial" ||
            item.name === "Annual Special" ||
            item.name === "5 Month Intro Plan" ||
            item.name === "90 Days Intro Plan" ||
            item.name === "Instant Signup Payment" ||
            item.name === "Free Registration")) ||
        (item.sub_name === "Order Forms" &&
          (item.name === "1 Hour Master Class" ||
            item.name === "Live Opportunity Call"))
          ? "d-none"
          : "d-flex"
      } m-3`}
      style={{ background: "#f8f9fa" }}
    >
      <div className="funnel-image-wrapper w-25 bg-gray-light rounded-left">
        <img
          src={item.funnel_images}
          alt={`${item.sub_name} funnel`}
          style={{ width: "100%", height: "100%" }}
          className={`${!showStats && "rounded-left"}`}
        />
      </div>
      <div
        className="stats-row w-100 rounded-right"
        style={{ padding: "15px" }}
      >
        <div className="d-space-between mb-2">
          <span className="text-md font-weight-bold text-dark">
            {item.sub_name === "Order Forms" && item.name === "Guest User" 
              ? "Guest User Stats" 
              : `${item.sub_name} -  ${item.name}`}
          </span>
          {item.link?.includes("welcome") && item.name !== "Guest User" && (
            <Tooltip arrow placement="left" title="Statistics">
              <button
                onClick={toggleStats}
                className={`btn ${
                  showStats ? "btn-white" : "btn-primary"
                } font-weight-normal px-3 py-1`}
              >
                <i
                  className={`fa fa-bar-chart ${
                    showStats ? "text-default" : "text-white"
                  }`}
                />
              </button>
            </Tooltip>
          )}

          {item.sub_name === "Order Forms" &&
            (item.name === "Guest User" ||
              item.name === "$1 Trial" ||
              item.name === "Annual Special" ||
              item.name === "5 Month Intro Plan" ||
              item.name === "90 Days Intro Plan" ||
              item.name === "Instant Signup Payment" ||
              item.name === "Free Registration" ||
              item.name === "7 Days Free Trial") && (
              <Tooltip arrow placement="left" title="Statistics">
                <button
                  onClick={toggleStats}
                  className={`btn ${
                    showStats ? "btn-white" : "btn-primary"
                  } font-weight-normal px-3 py-1`}
                >
                  <i
                    className={`fa fa-bar-chart ${
                      showStats ? "text-default" : "text-white"
                    }`}
                  />
                </button>
              </Tooltip>
            )}
        </div>
        {item.sub_name === "Order Forms" && item.name !== "Guest User" && (
          <p className="text-xs text-dark">
            {item.name === "7 Days Free Trial" &&
              SEVEN_DAYS_FREE_TRIAL_DESCRIPTION}
            {item.name === "$1 Trial" && $1_TRIAL_DESCRIPTION}
            {item.name === "Exclusive Member - Admin" &&
              EXCLUSIVE_MEMBER_ADMIN_DESCRIPTION}
            {item.name === "1 Hour Master Class" &&
              ONE_HOURMASTER_CLASS_DESCRIPTION}
            {item.name === "Live Opportunity Call" &&
              LIVE_OPPORTUNITY_CALL_DESCRIPTION}
            {item.name === "Annual Special" && ANNUAL_SPECIAL_DESCRIPTION}
            {item.name === "5 Month Intro Plan" && FIVE_MONTH_INTRO_DESCRIPTION}
            {item.name === "90 Days Intro Plan" && NINETY_DAY_INTRO_DESCRIPTION}
            {item.name === "Free Registration" && FREE_REGISTRATION_DESCRIPTION}
            {item.name === "Instant Signup Payment" && INSTANT_SIGNUP_PAYMENT_DESCRIPTION}
          </p>
        )}
        {item.sub_name !== "Order Forms" || item.name !== "Guest User" ? (
          <div className="position-relative w-100 mt-3">
            <input
              disabled
              type="text"
              value={item.link}
              style={{ paddingRight: "100px" }}
              className="form-control text-xs h-25 pr-5 py-1"
            />
            <span
              onClick={() => handleCopyClick(item.link)}
              className="position-absolute copy-button"
            >
              <i className="fa fa-link pr-1"></i>Copy
            </span>
          </div>
        ) : null}

        {/* Accordion stats section */}
        <div className={`stats-accordion ${showStats ? "open" : ""}`}>
          <div className="stats-grid text-xs d-start mb-2">
            <span>
              Visits: <strong>{statsData.views_count}</strong>{" "}
            </span>
            <span>
              {item.name === "Guest User" ? "Guests:" : "Leads:"}
              <Link
                className="btn btn-sm btn-primary ml-1"
                to={`/affiliate-program/${
                  item.name === "Guest User" ? "guest" : "leads"
                }?period=${filter.period}&funnel_type=${item.funnel_type}`}
              >
                {item.name === "Guest User"
                  ? statsData.guest_count
                  : statsData.leads_count}
              </Link>
            </span>
            <span>
              {item.name === "Guest User" ? "Guests Conv:" : "Opt In:"}{" "}
              <strong>
                {item.name === "Guest User"
                  ? statsData.guest_to_member_conv_percentage.toFixed(1)
                  : statsData.opt_in_percentage.toFixed(1)}
                %
              </strong>
            </span>
            <span>
              Members:{" "}
              <Link
                className="btn btn-sm btn-primary ml-1"
                to={`/affiliate-program/members?period=${filter.period}&funnel_type=${item.funnel_type}`}
              >
                {statsData.member_count}
              </Link>
            </span>
            <span>
              Members Conv:{" "}
              <strong>{statsData.member_conv_percentage.toFixed(1)}%</strong>
            </span>
            <span>
              Funnel Conv:{" "}
              <strong>{statsData.funnel_conv_percentage.toFixed(1)}%</strong>
            </span>
          </div>
        </div>
      </div>
      {processing && <DotPulseBackdrop />}
    </div>
  );
}

export default AllFunnelCard;
